<template>
    <div class="home__product-details">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="product-item">
                        <div class="photo">
                            <img
                                srcset="/images/promo/panels/gg2x.jpg 2x"
                                src="/images/promo/panels/gg1x.jpg"
                                width="160"
                                height="270"
                                alt="Double Glass Solar Panel"
                            />
                        </div>
                        <div class="text">
                            <strong>{{
                                $t("promo.Products - 1 heading")
                            }}</strong>
                            {{ $t("promo.Products - 1 subheading") }}
                        </div>
                        <div class="params justify-content-between">
                            <div class="item">
                                <strong>
                                    {{
                                        $t(
                                            "promo.Products - 1 details 1 bold"
                                        )
                                    }}
                                </strong>
                                {{ $t("promo.Products - 1 details 1 info") }}
                            </div>
                            <div class="item">
                                <strong>
                                    {{
                                        $t(
                                            "promo.Products - 1 details 2 bold"
                                        )
                                    }}
                                </strong>
                                {{ $t("promo.Products - 1 details 2 info") }}
                            </div>
                            <div class="item">
                                <strong>
                                    {{
                                        $t(
                                            "promo.Products - 1 details 3 bold"
                                        )
                                    }}
                                </strong>
                                {{ $t("promo.Products - 1 details 3 info") }}
                            </div>
                            <div class="item">
                                <strong>
                                    {{
                                        $t(
                                            "promo.Products - 1 details 4 bold"
                                        )
                                    }}
                                </strong>
                                {{ $t("promo.Products - 1 details 4 info") }}
                            </div>
                        </div>
                    </div>
                    <!-- /item -->
                    <div class="product-item">
                        <div class="photo">
                            <img
                                srcset="/images/promo/panels/gf2x.jpg 2x"
                                src="/images/promo/panels/gf1x.jpg"
                                width="160"
                                height="270"
                                alt="High Performance Glass Foil\"
                            />
                        </div>
                        <div class="text">
                            <strong>{{
                                $t("promo.Products - 2 heading")
                            }}</strong>
                            {{ $t("promo.Products - 2 subheading") }}
                        </div>
                        <div class="params justify-content-between">
                            <div class="item">
                                <strong>
                                    {{
                                        $t(
                                            "promo.Products - 2 details 1 bold"
                                        )
                                    }}
                                </strong>
                                {{ $t("promo.Products - 2 details 1 info") }}
                            </div>
                            <div class="item">
                                <strong>
                                    {{
                                        $t(
                                            "promo.Products - 2 details 2 bold"
                                        )
                                    }}
                                </strong>
                                {{ $t("promo.Products - 2 details 2 info") }}
                            </div>
                            <div class="item">
                                <strong>
                                    {{
                                        $t(
                                            "promo.Products - 2 details 3 bold"
                                        )
                                    }}
                                </strong>
                                {{ $t("promo.Products - 2 details 3 info") }}
                            </div>
                            <div class="item">
                                <strong>
                                    {{
                                        $t(
                                            "promo.Products - 2 details 4 bold"
                                        )
                                    }}
                                </strong>
                                {{ $t("promo.Products - 2 details 4 info") }}
                            </div>
                        </div>
                    </div>
                    <div class="inverter d-flex flex-column flex-md-row">
                        <div class="text">
                            <strong>
                                {{
                                    $t("promo.Products - inverter - heading")
                                }}</strong
                            >

                            <div
                                v-html="
                                    $t('promo.Products - inverter - info')
                                "
                            ></div>
                            <div
                                class="logos d-flex align-items-center justify-content-between"
                            >
                                <img
                                    srcset="/images/promo/huawei/logo2x.png 2x"
                                    src="/images/promo/huawei/logo1x.png"
                                    width="79"
                                    height="22"
                                    alt="huawei logo"
                                />
                                <img
                                    srcset="/images/promo/solar_edge/logo2x.png 2x"
                                    src="/images/promo/solar_edge/logo1x.png"
                                    width="86"
                                    height="22"
                                    alt="solar edge logo"
                                />
                                <img
                                    srcset="/images/promo/sma/logo2x.png 2x"
                                    src="/images/promo/sma/logo1x.png"
                                    width="35"
                                    height="22"
                                    alt="sma logo"
                                />
                            </div>
                        </div>
                        <div class="photos">
                            <div class="item">
                                <img
                                    srcset="/images/promo/inverter/1_2x.png 2x"
                                    src="/images/promo/inverter/1_1x.png"
                                    width="80"
                                    height="80"
                                    alt="inverter 1"
                                />
                            </div>
                            <div class="item">
                                <img
                                    srcset="/images/promo/inverter/2_2x.png 2x"
                                    src="/images/promo/inverter/2_1x.png"
                                    width="80"
                                    height="80"
                                    alt="inverter 2"
                                />
                            </div>
                            <div class="item">
                                <img
                                    srcset="/images/promo/inverter/3_2x.png 2x"
                                    src="/images/promo/inverter/3_1x.png"
                                    width="80"
                                    height="80"
                                    alt="inverter 3"
                                />
                            </div>
                            <div class="item">
                                <img
                                    srcset="/images/promo/inverter/4_2x.png 2x"
                                    src="/images/promo/inverter/4_1x.png"
                                    width="80"
                                    height="80"
                                    alt="inverter 4"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.inverter {
    margin-bottom: 72px;
    margin-top: 72px;
    .photos {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 2;

        column-gap: 10px;
        row-gap: 10px;
        @media (min-width: 768px) {
            width: 50%;
            min-width: 50%;
            padding-left: 16px;
        }

        .item {
            display: flex;
            align-items: center;
            justify-content: center;
            @media (max-width: 767px) {
                padding-top: 75%;
                position: relative;
                img {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translateY(-50%) translateX(-50%);
                }
            }
            background: linear-gradient(0deg, #f7f8fb, #f7f8fb),
                linear-gradient(0deg, #ececec, #ececec),
                linear-gradient(0deg, #ececec, #ececec), #ececec;
        }
    }
    .text {
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        color: #141430;

        @media (min-width: 768px) {
            width: 50%;
            min-width: 50%;
            padding-right: 16px;
        }
        .logos {
            @media (max-width: 767px) {
                margin-bottom: 30px;
            }
            img {
                height: 20px;
            }
        }
        strong {
            font-weight: 600;
            font-size: 18px;
        }
    }
}
.product-item {
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-template-rows: 2;
    margin-bottom: 42px;
    @media (max-width: 768px) {
        grid-template-columns: 1fr 2fr;
        align-items: center;
    }
    .photo {
        margin-right: 32px;
        grid-row: 1/3;
        @media (max-width: 768px) {
            grid-column-start: 1;
            grid-column-end: 2;
            grid-row: 1/2;
            height: 270px;
        }
    }
    .text {
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        color: #141430;
        margin-bottom: 20px;
        strong {
            display: block;
            font-weight: 600;
            font-size: 18px;
        }
    }
    .params {
        grid-column-start: 2;
        display: flex;
        flex-wrap: wrap;
        @media (max-width: 768px) {
            margin-top: 30px;
            grid-column-start: 1;
            grid-column-end: 3;
            grid-row: 2/2;
        }
        .item {
            border-top: 1px solid #cfd6ea;
            width: calc(50% - 18px);
            min-width: calc(50% - 18px);
            padding-top: 16px;
            padding-bottom: 16px;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            color: #141430 !important;

            strong {
                display: block;
                font-weight: 600;
            }
        }
    }
}
</style>
